import { fetchDashboardInfo, getPremiumsByPurchaseType, getPolicyCountByPurchaseType, 
    getPremiumTotals, getPoliciesSummaryCount, getMonthlyPolicyCount, 
    getWeeklySummary, getPolicyCommissions, getPremiumRates, getPolicyClaimsCount, getPremiumSummary 
} from '../utils/apiService';

export const FETCH_DASHBOARD_DATA = 'dashboard/FETCH_DASHBOARD_DATA';
export const FETCH_DASHBOARD_DATA_PENDING = 'dashboard/FETCH_DASHBOARD_DATA_PENDING';
export const FETCH_DASHBOARD_DATA_REJECTED = 'dashboard/FETCH_DASHBOARD_DATA_REJECTED';
export const FETCH_DASHBOARD_DATA_FULFILLED = 'dashboard/FETCH_DASHBOARD_DATA_FULFILLED';

export const FETCH_PREMIUMS_BY_TYPE = 'dashboard/FETCH_PREMIUMS_BY_TYPE';
export const FETCH_PREMIUMS_BY_TYPE_PENDING = 'dashboard/FETCH_PREMIUMS_BY_TYPE_PENDING';
export const FETCH_PREMIUMS_BY_TYPE_REJECTED = 'dashboard/FETCH_PREMIUMS_BY_TYPE_REJECTED';
export const FETCH_PREMIUMS_BY_TYPE_FULFILLED = 'dashboard/FETCH_PREMIUMS_BY_TYPE_FULFILLED';

export const FETCH_POLICY_COUNT_BY_PURCHASE_TYPE = 'dashbaord/FETCH_POLICY_COUNT_BY_PURCHASE_TYPE';
export const FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_PENDING = 'dashbaord/FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_PENDING';
export const FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_REJECTED = 'dashbaord/FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_REJECTED';
export const FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_FULFILLED = 'dashbaord/FETCH_POLICY_COUNT_BY_PURCHASE_TYPE_FULFILLED';

export const FETCH_PREMIUM_TOTALS = 'dashboard/FETCH_PREMIUM_TOTALS';
export const FETCH_PREMIUM_TOTALS_PENDING = 'dashboard/FETCH_PREMIUM_TOTALS_PENDING';
export const FETCH_PREMIUM_TOTALS_REJECTED = 'dashboard/FETCH_PREMIUM_TOTALS_REJECTED';
export const FETCH_PREMIUM_TOTALS_FULFILLED = 'dashboard/FETCH_PREMIUM_TOTALS_FULFILLED';

export const FETCH_POLICY_COUNT = 'dashboard/FETCH_POLICY_COUNT';
export const FETCH_POLICY_COUNT_PENDING = 'dashboard/FETCH_POLICY_COUNT_PENDING';
export const FETCH_POLICY_COUNT_REJECTED = 'dashboard/FETCH_POLICY_COUNT_REJECTED';
export const FETCH_POLICY_COUNT_FULFILLED = 'dashboard/FETCH_POLICY_COUNT_FULFILLED';

export const FETCH_MONTHLY_POLICY_COUNT = 'dashboard/FETCH_MONTHLY_POLICY_COUNT';
export const FETCH_MONTHLY_POLICY_COUNT_PENDING = 'dashboard/FETCH_MONTHLY_POLICY_COUNT_PENDING';
export const FETCH_MONTHLY_POLICY_COUNT_REJECTED = 'dashboard/FETCH_MONTHLY_POLICY_COUNT_REJECTED';
export const FETCH_MONTHLY_POLICY_COUNT_FULFILLED = 'dashboard/FETCH_MONTHLY_POLICY_COUNT_FULFILLED';

export const FETCH_WEEKLY_SUMMARY = 'dashboard/FETCH_WEEKLY_SUMMARY';
export const FETCH_WEEKLY_SUMMARY_PENDING = 'dashboard/FETCH_WEEKLY_SUMMARY_PENDING';
export const FETCH_WEEKLY_SUMMARY_REJECTED = 'dashboard/FETCH_WEEKLY_SUMMARY_REJECTED';
export const FETCH_WEEKLY_SUMMARY_FULFILLED = 'dashboard/FETCH_WEEKLY_SUMMARY_FULFILLED';

export const FETCH_POLICY_COMMISSIONS = 'dashboard/FETCH_POLICY_COMMISSIONS';
export const FETCH_POLICY_COMMISSIONS_PENDING = 'dashboard/FETCH_POLICY_COMMISSIONS_PENDING';
export const FETCH_POLICY_COMMISSIONS_REJECTED = 'dashboard/FETCH_POLICY_COMMISSIONS_REJECTED';
export const FETCH_POLICY_COMMISSIONS_FULFILLED = 'dashboard/FETCH_POLICY_COMMISSIONS_FULFILLED';

export const FETCH_PREMIUM_RATES = 'dashboard/FETCH_PREMIUM_RATES';
export const FETCH_PREMIUM_RATES_PENDING = 'dashboard/FETCH_PREMIUM_RATES_PENDING';
export const FETCH_PREMIUM_RATES_REJECTED = 'dashboard/FETCH_PREMIUM_RATES_REJECTED';
export const FETCH_PREMIUM_RATES_FULFILLED = 'dashboard/FETCH_PREMIUM_RATES_FULFILLED';

export const FETCH_COUNT = 'dashboad/FETCH_COUNT';
export const FETCH_COUNT_PENDING = 'dashboad/FETCH_COUNT_PENDING';
export const FETCH_COUNT_REJECTED = 'dashboad/FETCH_COUNT_REJECTED';
export const FETCH_COUNT_FULFILLED = 'dashboad/FETCH_COUNT_FULFILLED';

export const FETCH_PREMIUM_SUMMARY = 'dashboard/FETCH_PREMIUM_SUMMARY';
export const FETCH_PREMIUM_SUMMARY_PENDING = 'dashboard/FETCH_PREMIUM_SUMMARY_PENDING';
export const FETCH_PREMIUM_SUMMARY_REJECTED = 'dashboard/FETCH_PREMIUM_SUMMARY_REJECTED';
export const FETCH_PREMIUM_SUMMARY_FULFILLED = 'dashboard/FETCH_PREMIUM_SUMMARY_FULFILLED';


export const listPremiumSummary = () => {
    return {
        type: FETCH_PREMIUM_SUMMARY,
        payload: getPremiumSummary()
    }
}

export const fetchDashboardData = () => {
    const payload = fetchDashboardInfo();
    return {
        type: FETCH_DASHBOARD_DATA,
        payload
    }
};

export const fetchPremiumsByType = (insurer) => {
    const payload = getPremiumsByPurchaseType(insurer);
    return {
        type: FETCH_PREMIUMS_BY_TYPE,
        payload
    }
}

export const fetchPolicyCountByPurchaseType = (insurer) => {
    const payload = getPolicyCountByPurchaseType(insurer);
    return {
        type: FETCH_POLICY_COUNT_BY_PURCHASE_TYPE,
        payload
    }
}

export const fetchPremiumTotals = (insurer) => {
    const payload = getPremiumTotals(insurer);
    return {
        type: FETCH_PREMIUM_TOTALS,
        payload
    }
}

export const fetchPolicyCount = () => {
    const payload = getPoliciesSummaryCount()
    return {
        type: FETCH_POLICY_COUNT,
        payload
    }
}

export const fetchMonthlyPolicyCount = () => {
    const payload = getMonthlyPolicyCount();
    return {
        type: FETCH_MONTHLY_POLICY_COUNT,
        payload
    }
}

export const fetchWeeklySummary = () => {
    const payload = getWeeklySummary();
    return {
        type: FETCH_WEEKLY_SUMMARY,
        payload
    }
}

export const fetchPolicyCommissions = () => {
    const payload = getPolicyCommissions();
    return {
        type: FETCH_POLICY_COMMISSIONS,
        payload
    }
}

export const fetchPremiumRates = (filter) => {
    const payload = getPremiumRates(filter);
    return {
        type: FETCH_PREMIUM_RATES,
        payload
    }
}

export const fetchPolicyClaimsCount = () => {
    const payload = getPolicyClaimsCount();
    return {
        type: FETCH_COUNT,
        payload
    }
}





// WEBPACK FOOTER //
// ./src/actions/dashboard.js